import React from 'react';
import i18n from '../../i18n';
import {withFormik} from 'formik';
import {Typography, withStyles} from '@material-ui/core';
import {getMutationName, mergeWithDefault} from '../Form/utils';
import swal from 'sweetalert';
import {object, string, number} from 'yup';
import FormFields from './FormFields';
import Divider from '@material-ui/core/Divider';
import moment from 'moment';
import buildingMutations from '../../mutations/buildingMutations';
import buildingPersonnelMutations from "../../mutations/buildingPersonnelMutations";
import SaveEvent from '../SaveShortcut/FunctionComponent';
import Grid from "@material-ui/core/Grid";
import GraphQlLoading from "../GraphQl/Loading";
import GraphQlError from "../GraphQl/Error";
import Query from "react-apollo/Query";
import buildingQueries from "../../queries/buildingQueries";
import BuildingSubTable from "./BuildingSubTable";

const manipulateValuesBeforeSave = async (values) => {

    ['acceptance','warranty_period_end','start_of_construction']
        .forEach((item) => {
        if ( values[item] === '' || values[item] === null) {
            values[item] = null;
        } else {
            values[item] = moment(values[item]).format('YYYY-MM-DD HH:mm:ss');
        }
    });
    values["updated_at"] = moment().format('YYYY-MM-DD HH:mm:ss');
    return values;
};

const saveBuildingPersonnel = async (buildingId,personnel) => {

    if(buildingId && personnel) {
        const mutation = personnel.id ? buildingPersonnelMutations.updateBuildingPersonnel : buildingPersonnelMutations.createBuildingPersonnel;
        const queryName = getMutationName(mutation);
        if(!personnel.building_id) {
            personnel.building_id = buildingId;
        }
        const {data: result} = await window.apolloClient.mutate(
            { mutation, variables: {...personnel}, errorPolicy: "all"  }
        ).catch((e) => { console.log('graphQLErrors', e ) });

        return result[queryName];
    }
}

const saveBuilding = async (values) => {

    const mutation = values.id > 0 ? buildingMutations.updateBuilding : buildingMutations.createBuilding;
    const queryName = getMutationName(mutation);
    let data = await manipulateValuesBeforeSave(values);

    const {data: result} = await window.apolloClient.mutate(
        { mutation, variables: {...data}, errorPolicy: "all"  }
    ).catch((e) => { console.log('graphQLErrors', e ) });

    let buildingId = values.id || result[queryName].id;
    buildingId && await saveBuildingPersonnel(buildingId , values.personnel );

    return result[queryName];
};


const yupLabel = (name) => {
    return i18n.get('building.form.' + name);
};

const BuildingForm = (props) => {
    const {
        values,
        handleSubmit,
        classes,
    } = props;

    SaveEvent({handleSubmit});

    return (
        <form onSubmit={handleSubmit}>
            <FormFields {...props}>
                <Divider className={classes.divider}/>
                {(values.id && !values.parent_id) && (
                    <React.Fragment>
                        <Grid container>
                            <Grid item xs={12}>
                                <Typography variant={'h6'} color={'primary'} className={classes.vSpace}>
                                    {i18n.get('building.subordinate_houses')}
                                </Typography>
                            </Grid>
                            <Query
                                query={buildingQueries.getSubordinates}
                                variables={{parent_id: values.id}}
                            >
                                {({loading, error, data}) => {

                                    if (loading) {
                                        return <GraphQlLoading style={{margin:10}} />;
                                    }
                                    if (error) {
                                        return <GraphQlError style={{margin:10}}/>;
                                    }

                                    return data.buildings && data.buildings.data.length > 0
                                        ? <BuildingSubTable buildings={data.buildings.data} />
                                        : <div>{i18n.get('default.empty')}</div>
                                }}
                            </Query>
                        </Grid>
                    </React.Fragment>
                )}
            </FormFields>
        </form>
    );
};

const FormConfig = withFormik({
    mapPropsToValues: props => mergeWithDefault(props.values, {
        id: '',
        name: '',
        code: '',
        street: '',
        number: '',
        zip: '',
        city: '',
        district: '',
        state: '',
        acceptance: '',
        warranty_period_start: '',
        warranty_period_end: '',
        start_of_construction: '',
        user_id: window.__DATA__._user.id,
        editor: null,
        builder_id:'',
        builder: null,
        contact_id: '',
        parent_id:'',
        parent: null,
        children: null,
        cost_center_id: '',
        cost_center: '',
        journals_count: 0,
        print_filter: null,
        completed: false,
    }),
    validationSchema: (request) => {
        let hasParent = !!request.values.parent;
        let rules = {
            name: string().label(yupLabel(hasParent ? 'house_name' : 'name')).min(3).required(),
            street: string().label(yupLabel('street')).required(),
            number: string().label(yupLabel('number')).required(),
            zip: !hasParent && string().label(yupLabel('zip')).min(5).required(),
            city: !hasParent && string().label(yupLabel('city')).required(),
            //acceptance: date().label(yupLabel('acceptance')).required(),
            //warranty_period_end: date().label(yupLabel('warranty_period_end')),
            //start_of_construction: string().label(yupLabel('start_of_construction')).required(),
            builder_id: number().label(yupLabel('builder')).required(),
            contact_id: number().label(yupLabel('contact')).required(),
        };
        return object().shape(rules);
    },
    handleSubmit: (values, {setSubmitting}) => {
        setSubmitting(true);

        saveBuilding(values).then(data => {

            setSubmitting(false);

            // Show success message.
            return swal({
                title: i18n.get('building.msg.save_success'),
                text: i18n.get('building.msg.you_will_be_redirected'),
                icon: 'success',
                timer: 4000,
            }).then(() => {
                if (data.id > 0) {
                    if(data.parent_id) {
                        window.location.href = `/construction/${data.parent_id}/edit`;
                    } else {
                        window.location.href = document.referrer; // `/construction`;
                    }
                }
            });

        });
    },
    validateOnBlur: true,
})(BuildingForm);

const styles = theme => ({
    deleteButton: {
        background: theme.colors.error,
    },
    divider: {
        marginTop: theme.spacing.unit * 2,
        marginBottom:theme.spacing.unit * 2,
    },
    vSpace: {
        marginTop: theme.spacing.unit * 2,
    },
    addButton: {
        marginTop: 16,
    },
    iconButton: {
        width: 32,
        height: 32,
        fontSize: 12,
        padding: '8px',
        opacity: 0.5,
        '&:hover': {
            color: theme.colors.primary,
            opacity: 1,
            outline:'none',
        },
        '&:focus': {
            outline:'none',
        }
    },
    iconButtonActive:{
        width: 32,
        height: 32,
        fontSize: 12,
        padding: '8px',
        color: theme.colors.primary,
        opacity: 1,
        '&:hover': {
            opacity: 0.5,
            outline:'none',
            color: theme.colors.lightGreyBlue,
        },
        '&:focus': {
            outline:'none',
        }
    },
    iconButtonIcon: {
        fontSize: 22,
    },
});

export default withStyles(styles)(FormConfig);
